<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import CloseIcon from '../../asset/CloseIcon.vue'

const modalOpen = ref(false)
const keycloakLoginLink = ref(window.condaKeycloakLoginLink)
const keycloakRegisterLink = ref(window.condaKeycloakRegisterLink)

function eventFunction() {
    modalOpen.value = true
}

function handleOpenLoginModal() {
    modalOpen.value = true
}

onMounted(() => {
    const buttons = window.document.querySelectorAll('.please-log-in')
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', eventFunction)
    }
    window.addEventListener('open-login-modal', handleOpenLoginModal)
})

onUnmounted(() => {
    const buttons = window.document.querySelectorAll('.please-log-in')
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].removeEventListener('click', eventFunction)
    }
    window.removeEventListener('open-login-modal', handleOpenLoginModal)
})

function closeModal() {
    modalOpen.value = false
}

function navigateTo(url: string) {
    window.location.href = url
}
</script>

<template>
    <Transition name="modal-backdrop">
        <div
            v-if="modalOpen"
            class="modal-backdrop fixed left-0 top-0 z-[500] flex h-screen w-full items-center justify-center bg-black/60"
            @click="closeModal">
            <Transition name="modal-content">
                <div
                    v-if="modalOpen"
                    class="modal-content-inner relative flex w-full max-w-md flex-col items-center justify-start space-y-4 rounded-md bg-white p-4"
                    @click.stop>
                    <CloseIcon
                        class="absolute right-2 top-2 h-6 w-6 cursor-pointer text-primary-500"
                        @click="closeModal" />
                    <p class="text-center text-lg font-bold">{{ $t('header_modal_title_new') }}</p>
                    <p class="text-sm text-gray-500">
                        {{ $t('header_modal_body_new') }}
                    </p>
                    <div class="flex w-full flex-col gap-4">
                        <button
                            class="w-full rounded-md border border-primary-500 bg-primary-500 p-2 text-white"
                            @click="navigateTo(keycloakLoginLink)">
                            {{ $t('header_sign_in_new') }}
                        </button>
                        <div class="flex h-auto w-full items-center justify-center space-x-2">
                            <div class="h-px w-1/2 bg-gradient-to-r from-transparent to-primary-500"></div>
                            <p class="whitespace-nowrap text-sm text-gray-500">{{ $t('header_new_to_invest_new') }}</p>
                            <div class="h-px w-1/2 bg-gradient-to-l from-transparent to-primary-500"></div>
                        </div>
                        <button
                            class="w-full rounded-md border border-primary-500 bg-white p-2 text-primary-500"
                            @click="navigateTo(keycloakRegisterLink)">
                            {{ $t('header_register_new') }}
                        </button>
                    </div>
                </div>
            </Transition>
        </div>
    </Transition>
</template>

<style scoped>
.modal-backdrop-enter-active {
    transition: opacity 0.3s ease;
}
.modal-backdrop-leave-active {
    transition: opacity 0.25s ease;
}
.modal-backdrop-enter-from,
.modal-backdrop-leave-to {
    opacity: 0;
}

.modal-content-enter-active {
    transition: opacity 0.4s ease 0.5s, transform 0.4s ease 0.5s;
}
.modal-content-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}
.modal-content-enter-from,
.modal-content-leave-to {
    opacity: 0;
    transform: translateY(-24px);
}
</style>
